import styled from 'styled-components';

export const DashboardContainer = styled.div`
  min-height: 100vh;
  background: var(--bg-main);
  padding: 2rem;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  h1 {
    color: var(--text-main);
    margin: 0;
  }
`;

export const SectionCard = styled.div`
  background: var(--bg-card);
  padding: 2rem;
  border-radius: 12px;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

export const TabBar = styled.div`
  display: flex;
  margin-bottom: 1rem;

  button {
    margin-right: 1rem;
  }
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 3rem;
  color: var(--text-secondary);
`;
